import React from 'react'
import { Box, Button, Grid } from '@chatterbug/aaron'

import routes from 'src/lib/rails-routes/rails-routes'
import { t } from 'src/lib/i18n-react'
import { usePageParams } from 'src/utils/params'

const Empty = () => {
  const { l2Code } = usePageParams()
  const navigateToTopics = () => {
    window.location.href = routes.advanced_topics(l2Code)
  }

  return (
    <Grid
      backgroundColor="white100"
      borderColor="gray88"
      borderStyle="dashed"
      borderWidth="2px"
      p="4x"
      borderRadius="1x"
      gridGap="2x"
    >
      <Box as="h3" variant="text.h4" lineHeight="s">
        {t("You haven't added anything yet")}
      </Box>
      <Box as="p" variant="text.paragraph" lineHeight="lg">
        {t(
          'Start off by exploring topics and units. Once you add them they will appear here.'
        )}
      </Box>
      <Box mt="2x">
        <Button type="primaryAdvanced" onClick={() => navigateToTopics()}>
          {t('Add topics')}
        </Button>
      </Box>
    </Grid>
  )
}

export default Empty
